import * as remoteAction from "../remoteAction";

export type GetLedgerContextActionSuccess = remoteAction.MerchantRemoteResponse<
  "LOYALTY_GET_LEDGER_CONTEXT_SUCCESS",
  any
>;
export type GetLedgerContextActionFailure = remoteAction.MerchantRemoteResponse<
  "LOYALTY_GET_LEDGER_CONTEXT_FAILURE",
  any
>;
export type GetLedgerContextActionRequest = remoteAction.MerchantRemoteResponse<
  "LOYALTY_GET_LEDGER_CONTEXT_REQUEST",
  any
>;

export interface GetLedgerContextAction extends remoteAction.GetRemoteRequest {
  types: {
    request: "LOYALTY_GET_LEDGER_CONTEXT_REQUEST";
    success: "LOYALTY_GET_LEDGER_CONTEXT_SUCCESS";
    failure: "LOYALTY_GET_LEDGER_CONTEXT_FAILURE";
  };
}

export interface GetLedgerContextParams {
  currency?: string;
}

export const getLedgerContext = ({
  currency = "USD",
}: GetLedgerContextParams): GetLedgerContextAction => ({
  type: "MERCHANT_REMOTE_REQUEST",
  types: {
    request: "LOYALTY_GET_LEDGER_CONTEXT_REQUEST",
    failure: "LOYALTY_GET_LEDGER_CONTEXT_FAILURE",
    success: "LOYALTY_GET_LEDGER_CONTEXT_SUCCESS",
  },
  method: "GET",
  https: true,
  params: {
    currency,
  },
  url: `/rewards/ledger-context`,
});
